import React from "react";
import Topbar from "../components/Topbar";
import Card from "react-bootstrap/Card";
import { Col } from "react-bootstrap";
import LessonList from "../components/LessonList";

/**
 * Lessons page that shows all the current lessons
 */
class LessonsStudent extends React.Component {
  render() {
    return (
      <div
        // style={{
        //   backgroundColor: "#93f4ff",
        //   backgroundImage: "linear-gradient(0deg, #93f4ff 0%, #ffffff 100%)",
        //   overflow: "auto",
        // }}
        className = "page"
      >
        <Topbar isLessonPage = {true} />
        <div style={{ height: "20px" }}></div>
        <div className="d-flex justify-content-center">
          <Card>
            <Col>
              <LessonList />
            </Col>
          </Card>
        </div>
      </div>
    );
  }
}

export default LessonsStudent;
